import { formatDate } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { ServiceCost } from './service-cost.models';

@Injectable({
	providedIn: 'root'
})
export class ServiceCostService {
	private getCostUrl = `${environment.apiBaseUrl}/servicecost/type`;
	private serviceCostUrl = `${environment.apiBaseUrl}/servicecost`;
	private getVatRateUrl = `${environment.apiBaseUrl}/servicecost/getVatRate`;

	constructor(private http: HttpClient) {}

	public getServiceCostByRequestType(requestType: number): Observable<ServiceCost[]> {
		return this.http.get<ServiceCost[]>(`${this.getCostUrl}/${requestType}`);
	}

	public getServiceCostByCodeId(codeId: number): Observable<ServiceCost> {
		return this.http.get<ServiceCost>(`${this.serviceCostUrl}/${codeId}`);
	}

	public getServiceCostByCodeIds(codeIds: number[]): Observable<ServiceCost[]> {
		let params = new HttpParams();
		for (const id of codeIds) {
			params = params.append('ids', id);
		}
		return this.http.get<ServiceCost[]>(`${this.serviceCostUrl}`, { params });
	}

	public getVatRate(date: Date) {
		let dateString = formatDate(date, 'yyyy-MM-dd', 'en-US');
		return this.http.get<number>(`${this.getVatRateUrl}/${dateString}`);
	}
}
